module.exports = __webpack_public_path__ + "9c52ef7b4e3256b1ecf8c576bad830b9.glb";